/*
 * @Author: llzq
 * @Date: 2021-01-12 15:54:45
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 18:48:49
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {Modal,Row,Col,Button} from "antd";

// model
import MessageDetails from '../../../notice/model/messageDetails'
// img
import TeachEvaluaIcon from '@/assets/image/head/teachevalua.svg'

import './style.less'

interface iProps {
    onCancel: () => void;
    deleteMessage: () => void;
    visible: boolean;
    msg: MessageDetails
}
export default class messageDetails extends Component<iProps> {
    onOk = () => {
    };
    render() {
        const { visible, onCancel, msg, deleteMessage } = this.props
        return (
            <Modal
            width="480px"
            title="消息详情"
            visible={visible}
            onOk={this.onOk}
            onCancel={onCancel}
            footer={null}
            className="messageModal"
            >
                <div className="messageModal_content">
                    <div>
                        <img src={TeachEvaluaIcon} width="64" height="64" />
                    </div>
                    <Row className='mt16'>
                        <Col span={12}>
                            <span className="boldTitle">发布人：</span>{msg.systemName}
                        </Col>
                        <Col span={12}>
                            <span className="boldTitle">发布时间：</span>{msg.sendTime}
                        </Col>
                    </Row>
                    <div className="boldTitle mt10">消息内容：</div>
                    <div className="mt8">
                        {msg.content}
                    </div>
                </div>
                <div className="messageModal_footer">
                    <Button onClick={deleteMessage}>删除</Button>
                    {msg.pcAction &&
                        <Button type="primary">查看</Button>}
                </div>
            </Modal>
        )
    }
}
